import { createSlice } from '@reduxjs/toolkit';
import { customerViewInitialState } from './customerViewInitialState';
import _ from 'lodash';

const customerViewSlice = createSlice({
  name: 'customerView',
  initialState: customerViewInitialState,
  reducers: {
    resetCVStore: (state) => {
      return {
        ...customerViewInitialState,
      };
    },
    //used set  all focus accounts when user uncheck the focus_account checkbox
    setSeletedView: (state, action) => {
      state.selectedView = action.payload;
    },
    setAllAccountOptions: (state, action) => {
      state.allAccountOptions = action.payload;
    },
    setAllSiteOptions: (state, action) => {
      state.allSiteOptions = action.payload;
    },
    setEcosystemOptions: (state, action) => {
      state.ecosystemOptions = action.payload;
    },
    setProductOptions: (state, action) => {
      state.productOptions = action.payload;
    },
    setAllProductOptions: (state, action) => {
      state.allProductOptions = action.payload;
    },
    setSquadOptions: (state, action) => {
      state.squadOptions = action.payload;
    },
    setAllSquadOptions: (state, action) => {
      state.allSquadOptions = action.payload;
    },
    setTimePeriodOptions: (state, action) => {
      state.timePeriodOptions = action.payload;
    },
    setTimePeriods: (state, action) => {
      state.timePeriod = action.payload;
    },
    setSelectedAccount: (state, action) => {
      state.selectedAccount = action.payload;
    },
    setSelectedEcosystem: (state, action) => {
      state.selectedEcosystem = action.payload;
    },
    setSelectedSquad: (state, action) => {
      state.selectedSquad = action.payload;
    },

    setSelectedTimePeriod: (state, action) => {
      state.selectedTimePeriod = action.payload;
    },
    setSelectedSiteView: (state, action) => {
      state.selectedSiteView = action.payload;
    },
    setFocusAccountChecked: (state, action) => {
      state.focusAccountChecked = action.payload;
    },
    setFocusAccountDisabled: (state, action) => {
      state.focusAccountDisabled = action.payload;
    },
    setPrevFocusAccountChecked: (state, action) => {
      state.prevFocusAccountChecked = action.payload;
    },
    setFocusSiteChecked: (state, action) => {
      state.focusSiteChecked = action.payload;
    },
    setIsAccountAvailable: (state, action) => {
      state.isAccountAvailable = action.payload;
    },
    setViewName: (state, action) => {
      state.viewName = action.payload;
    },
    setKpiId: (state, action) => {
      state.kpiId = action.payload;
    },
    setKpiName: (state, action) => {
      state.kpiName = action.payload;
    },
    setDimensionName: (state, action) => {
      state.dimensionName = action.payload;
    },
    setChartData: (state, action) => {
      state.chartData = action.payload;
    },
    setTableData: (state, action) => {
      state.tableData = action.payload;
    },
    setCards: (state, action) => {
      state.cards = _.uniqBy(action.payload, 'cardId');
    },
    appendCards: (state, action) => {
      // Append new cards to existing cards for pagination
      state.cards = _.uniqBy([...state.cards, ...action.payload], 'cardId');
    },
    setTimespan: (state, action) => {
      state.timespan = action.payload;
    },
    setSiteExpression: (state, action) => {
      state.siteExpression = action.payload;
    },
    setAffiliationsExpression: (state, action) => {
      state.affiliationsExpression = action.payload;
    },
    setSiteUtilizationExpression: (state, action) => {
      state.siteUtilizationExpression = action.payload;
    },
    setPrductMixExpression: (state, action) => {
      state.productMixExpression = action.payload;
    },
    setSelectedKPI: (state, action) => {
      state.selectedKPI = action.payload;
    },
    setNoDimensionValue: (state, action) => {
      state.noDimensionValue = action.payload;
    },
    setBenchmarkNoDimensionValue: (state, action) => {
      state.benchmarkNoDimensionValue = action.payload;
    },
    setSelectedKpiName: (state, action) => {
      state.selectedKpiName = action.payload;
    },
    setShowSuccess: (state, action) => {
      state.showSuccess = action.payload;
    },
    setAccountDetails: (state, action) => {
      state.accountDetails = action.payload;
    },
    setBeamChart: (state, action) => {
      state.beamChart = action.payload;
    },
    setBeamChartSite: (state, action) => {
      state.beamChartSite = action.payload;
    },
    setCRMScores: (state, action) => {
      state.crmScores = action.payload;
    },
    setCrmPercent: (state, action) => {
      state.crmPercent = action.payload;
    },
    setCrmQuarter: (state, action) => {
      state.crmQuarter = action.payload;
    },
    setSurveyTotal: (state, action) => {
      state.surveyTotal = action.payload;
    },
    setPaymentMethod: (state, action) => {
      state.paymentMethod = action.payload;
    },
    setInsightBoards: (state, action) => {
      state.insightBoards = action.payload;
    },
    setContacts: (state, action) => {
      state.contacts = action.payload;
    },
    setSelectedAccountId: (state, action) => {
      state.selectedAccountId = action.payload;
    },
    setChartType: (state, action) => {
      state.chartType = action.payload;
    },

    // Engagement
    setEngagementFilters: (state, action) => {
      state.engagementFilters = action.payload;
    },
    resetEngagementFilters: (state) => {
      state.engagementFilters = {
        ...customerViewInitialState.engagementFilters,
      };
    },
    setStakeholderName: (state, action) => {
      state.engagementFilters.StakeholderName = action.payload;
    },
    setStakeholderType: (state, action) => {
      state.engagementFilters.StakeholderType = action.payload;
    },
    setEngagement: (state, action) => {
      state.engagementFilters.Engagement = action.payload;
    },
    setSelectedEngagement: (state, action) => {
      state.engagementFilters.Engagement.selectedValue = action.payload;
    },
    setBrand: (state, action) => {
      state.engagementFilters.Brand = action.payload;
    },
    setSquad: (state, action) => {
      state.engagementFilters.Squad = action.payload;
    },
    setIndication: (state, action) => {
      state.engagementFilters.Indication = action.payload;
    },
    setEngagmentEcosystem: (state, action) => {
      state.engagementFilters.EngagementEcosystem = action.payload;
    },
    setUserName: (state, action) => {
      state.engagementFilters.GNE_User_Name = action.payload;
    },
    setUserRole: (state, action) => {
      state.engagementFilters.GENE_User_Role = action.payload;
    },
    setMarketingFilters: (state, action) => {
      state.marketingFilters = action.payload;
    },
    setChannelFilters: (state, action) => {
      state.marketingFilters.Channel = action.payload;
    },
    setDiscussionTopicFilters: (state, action) => {
      state.marketingFilters.DiscussionTopic = action.payload;
    },
    setStakeholderTypeFilters: (state, action) => {
      state.marketingFilters.PayerStakeholderType = action.payload;
    },
    setTemplateNameFilters: (state, action) => {
      state.marketingFilters.TemplateName = action.payload;
    },
    setSurveyTypeFilters: (state, action) => {
      state.marketingFilters.SurveyType = action.payload;
    },
    setPresentationNameFilters: (state, action) => {
      state.marketingFilters.PresentationName = action.payload;
    },
    setKeyMessageFilters: (state, action) => {
      state.marketingFilters.KeyMessage = action.payload;
    },

    // Affiliations
    setAffiliationFilters: (state, action) => {
      state.affiliationsFilters = action.payload;
    },
    resetAffiliationFilters: (state) => {
      state.affiliationsFilters = customerViewInitialState.affiliationsFilters;
    },
    setSiteFilters: (state, action) => {
      state.siteFilter = action.payload;
    },
    setSiteName: (state, action) => {
      state.affiliationsFilters.SiteName_Address = action.payload;
    },
    setSiteHCPAddress: (state, action) => {
      state.affiliationsFilters.HCPAddress = action.payload;
    },
    setSiteState: (state, action) => {
      state.affiliationsFilters.SiteState = action.payload;
    },
    setSiteHIN: (state, action) => {
      state.affiliationsFilters.SiteHIN = action.payload;
    },
    setSiteAddress: (state, action) => {
      state.affiliationsFilters.SiteAddress = action.payload;
    },
    setSiteHCPStakeholderType: (state, action) => {
      state.affiliationsFilters.HCPStakeholderTypes = action.payload;
    },
    setSiteHCPName: (state, action) => {
      state.affiliationsFilters.HCPNames = action.payload;
    },
    setSiteSpecility: (state, action) => {
      state.affiliationsFilters.SiteSpeciality = action.payload;
    },

    // Site Utilixations
    setSiteUtilizationFilters: (state, action) => {
      state.siteUtilizationFilters = action.payload;
    },
    resetSiteUtilizationFilters: (state) => {
      state.siteUtilizationFilters =
        customerViewInitialState.siteUtilizationFilters;
    },
    setSiteUtilizationEcosystem: (state, action) => {
      state.siteUtilizationFilters.SiteUtilization_Ecosystem = action.payload;
    },
    setSiteUtilizationSite: (state, action) => {
      state.siteUtilizationFilters.SiteUtilization_SiteName_Address =
        action.payload;
    },
    setSiteUtilizationAddress: (state, action) => {
      state.siteUtilizationFilters.SiteUtilization_Site_Address =
        action.payload;
    },
    setSiteUtilizationSiteCity: (state, action) => {
      state.siteUtilizationFilters.SiteUtilization_SiteCity = action.payload;
    },
    setSiteUtilizationSiteState: (state, action) => {
      state.siteUtilizationFilters.SiteUtilization_SiteState = action.payload;
    },

    // Payer Mix
    setPayerMixFilters: (state, action) => {
      state.payerMixFilters = action.payload;
    },
    setPayerMixFilterInitailState: (state, action) => {
      state.payerMixFilters = customerViewInitialState.payerMixFilters;
    },
    setParentPayer: (state, action) => {
      state.payerMixFilters.Parent_Payer = action.payload;
    },
    setPayerMixPayer: (state, action) => {
      state.payerMixFilters.Payer = action.payload;
    },
    setBookofBusiness: (state, action) => {
      state.payerMixFilters.Book_Of_Business = action.payload;
    },
    setBenifitType: (state, action) => {
      state.payerMixFilters.Benifit_Type = action.payload;
    },
    setPayerProduct: (state, action) => {
      state.payerMixFilters.Payer_Mix_Product = action.payload;
    },
    setPayerIndication: (state, action) => {
      state.payerMixFilters.Payer_Indication = action.payload;
    },
    setCompetitor: (state, action) => {
      state.payerMixFilters.Competitor_Brand = action.payload;
    },
    setPayerEcosystem: (state, action) => {
      state.payerMixFilters.Payer_Ecosystem = action.payload;
    },

    // Policy Details
    setPolicyDetailsFilters: (state, action) => {
      state.policyDetailsFilters = action.payload;
    },
    setPolicyDetailsIniState: (state) => {
      state.policyDetailsFilters =
        customerViewInitialState.policyDetailsFilters;
    },
    setPolicyDetailsPayer: (state, action) => {
      state.policyDetailsFilters.Payer = action.payload;
    },
    setPolicyDetailsPlan: (state, action) => {
      state.policyDetailsFilters.Plan = action.payload;
    },
    setPolicyDetailsProduct: (state, action) => {
      state.policyDetailsFilters.Product = action.payload;
    },
    setPolicyDetailsIndication: (state, action) => {
      state.policyDetailsFilters.Indication = action.payload;
    },
    setPolicyDetailsCompetitorProduct: (state, action) => {
      state.policyDetailsFilters.CompetitorProduct = action.payload;
    },
    setPolicyDetailsEcosystemName: (state, action) => {
      state.policyDetailsFilters.EcosystemName = action.payload;
    },
    setPolicyDetailsPolicyState: (state, action) => {
      state.policyDetailsFilters.PolicyState = action.payload;
    },
    setPolicyDetailsBookOfBusiness: (state, action) => {
      state.policyDetailsFilters.BookOfBusiness = action.payload;
    },
    setPolicyDetailsBenefitType: (state, action) => {
      state.policyDetailsFilters.BenefitType = action.payload;
    },

    // Ecosystem Opportunity
    setEcosystemOpportunityFilters: (state, action) => {
      state.ecosystemOpportunityFilters = action.payload;
    },
    setEcosystemOpportunityInitailState: (state) => {
      state.ecosystemOpportunityFilters =
        customerViewInitialState.ecosystemOpportunityFilters;
    },
    setEcosystemOpportunityProduct: (state, action) => {
      state.ecosystemOpportunityFilters.EcoOppProduct = action.payload;
    },
    setEcosystemOpportunityIndication: (state, action) => {
      state.ecosystemOpportunityFilters.EcoOppIndication = action.payload;
    },
    setEcosystemOpportunityCompetitorBrand: (state, action) => {
      state.ecosystemOpportunityFilters.EcoOppCompetitorProduct =
        action.payload;
    },
    setEcosystemOpportunityBookOfBusiness: (state, action) => {
      state.ecosystemOpportunityFilters.EcoOppBookOfBusiness = action.payload;
    },
    setEcosystemOpportunityBenefitType: (state, action) => {
      state.ecosystemOpportunityFilters.EcoOppBenefitType = action.payload;
    },
    setEcosystemOpportunityRegion: (state, action) => {
      state.ecosystemOpportunityFilters.EcoOppRegion = action.payload;
    },
    setEcosystemOpportunityEcosystem: (state, action) => {
      state.ecosystemOpportunityFilters.EcoOppEcosystemName = action.payload;
    },

    // Site Performance
    setSitePerformanceFilters: (state, action) => {
      state.sitePerformanceFilters = action.payload;
    },
    resetSitePerformanceFilters: (state, action) => {
      const retainTimePeriod = action.payload?.retainTimePeriod;
      const { IsAccountableProduct, TimePeriod } = state.sitePerformanceFilters;

      state.sitePerformanceFilters = {
        ...customerViewInitialState.sitePerformanceFilters,
        IsAccountableProduct,
        ...(retainTimePeriod && { TimePeriod }),
      };
    },
    setSites: (state, action) => {
      state.sitePerformanceFilters.Site_Performance_SiteName_Address =
        action.payload;
    },
    setProducts: (state, action) => {
      state.sitePerformanceFilters.Product = action.payload;
    },
    setEcosystem: (state, action) => {
      state.sitePerformanceFilters.Ecosystem = action.payload;
    },
    setSitePerformanceSquad: (state, action) => {
      state.sitePerformanceFilters.SiteSquad = action.payload;
    },
    setIsAccountableProduct: (state, action) => {
      state.sitePerformanceFilters.IsAccountableProduct = action.payload;
    },
    setContractSegmentFilter: (state, action) => {
      state.sitePerformanceFilters.contract_segment_Filter = action.payload;
    },
    setSitePerformanceTimePeriod: (state, action) => {
      state.sitePerformanceFilters.TimePeriod = action.payload;
    },
    setCustomerInsightBoardId: (state, action) => {
      state.custInsightsBrdId = action.payload;
    },
    setInsightType: (state, action) => {
      state.insightType = action.payload;
    },
    setHcpFlag: (state, action) => {
      state.hcpFlag = action.payload;
    },
    setExportLoader: (state, action) => {
      action.payload.data === 'affiliation'
        ? (state.exportAffiliation = action.payload.export)
        : action.payload.data === 'siteutilization'
          ? (state.exportSiteUtilizaztion = action.payload.export)
          : action.payload.data === 'accountpayermix'
            ? (state.exportAccountpayermix = action.payload.export)
            : action.payload.data === 'copayanalytics'
              ? (state.exportCopayAnalytics = action.payload.export)
              : action.payload.data === 'policydetailstable'
                ? (state.exportPolicyDetails = action.payload.export)
                : action.payload.data === 'ecosystemopportunity'
                  ? (state.exportEcosystemOpportunity = action.payload.export)
                  : (state.exportSite = action.payload.export);
    },

    // Copay
    setCopayCustomColumn: (state, action) => {
      state.copayCustomColumn = action.payload;
    },
    setCopayAnalyticsFilters: (state, action) => {
      state.copayAnalyticsFilters = action.payload;
    },
    setCopayAnalyticsFiltersInitialState: (state) => {
      state.copayAnalyticsFilters =
        customerViewInitialState.copayAnalyticsFilters;
    },
    setCopayAllEcosystem: (state, action) => {
      state.copayAllEcosystem = action.payload;
    },
    setCopayAnalyticsEcosystem: (state, action) => {
      state.copayAnalyticsFilters.copayEcosystem = action.payload;
    },
    setCopayAnalyticsProduct: (state, action) => {
      state.copayAnalyticsFilters.copayProduct = action.payload;
    },
    setCopayAnalyticsSquad: (state, action) => {
      state.copayAnalyticsFilters.copaySquad = action.payload;
    },
    setCopayAnalyticsSiteName: (state, action) => {
      state.copayAnalyticsFilters.copaySiteAddressName = action.payload;
    },
    setCopayAnalyticsTimePeriod: (state, action) => {
      state.copayAnalyticsFilters.copayQuarter = action.payload;
    },
    setHCPName: (state, action) => {
      state.siteInfoFilters.HCPName = action.payload;
    },
    setHCPStakeholderType: (state, action) => {
      state.siteInfoFilters.HCPStakeholderType = action.payload;
    },
    setHCPSpeciality: (state, action) => {
      state.siteInfoFilters.Speciality = action.payload;
    },
    setHCPState: (state, action) => {
      state.siteInfoFilters.State = action.payload;
    },
    setHCPCity: (state, action) => {
      state.siteInfoFilters.City = action.payload;
    },
    setHCPZip: (state, action) => {
      state.siteInfoFilters.Zip = action.payload;
    },

    // Product Mix
    setProductMixFilters: (state, action) => {
      state.productMixFilters = action.payload;
    },
    setProductMixFiltersIntitalState: (state) => {
      state.productMixFilters = customerViewInitialState.productMixFilters;
    },
    setProductMixProduct: (state, action) => {
      state.productMixFilters.Product = action.payload;
    },
    setProductMixSquad: (state, action) => {
      state.productMixFilters.SiteSquad = action.payload;
    },
    setIsAccountableProductMix: (state, action) => {
      state.productMixFilters.IsAccountableProduct = action.payload;
    },
    setProductMixTimePeriod: (state, action) => {
      state.productMixFilters.TimePeriod = action.payload;
    },
    resetProductMixFilters: (state, action) => {
      const retainTimePeriod = action.payload?.retainTimePeriod;
      const { IsAccountableProduct, TimePeriod } = state.productMixFilters;
      state.productMixFilters = {
        ...customerViewInitialState.productMixFilters,
        IsAccountableProduct,
        ...(retainTimePeriod && { TimePeriod }),
      };
    },

    // Configure Insight
    setConfigureInsightFilters: (state, action) => {
      state.configureInsightsFilters = action.payload;
    },
    setConfigureInsightProducts: (state, action) => {
      state.configureInsightsFilters.Product = action.payload;
    },
    setConfigureInsightSquad: (state, action) => {
      state.configureInsightsFilters.SiteSquad = action.payload;
    },
    setConfigureInsightEcosystem: (state, action) => {
      state.configureInsightsFilters.Ecosystem = action.payload;
    },
    setConfigInsightSiteFilter: (state, action) => {
      state.configureInsightsFilters.SiteName_Address = action.payload;
    },
    setIsAccountableProductConfigure: (state, action) => {
      state.configureInsightsFilters.IsAccountableProduct = action.payload;
    },
    setAppUsers: (state, action) => {
      state.appUsers = action.payload;
    },
    setColumnRestricted: (state, action) => {
      state.columnsRestiction = action.payload;
    },
    setExcelColumnRestiction: (state, action) => {
      state.excelColumnsRestiction = action.payload;
    },
    setNotificationEmailStatus: (state, action) => {
      state.notificationEmailStatus = action.payload;
    },
    setNotifyuserList: (state, action) => {
      state.notifyUsersByEmailList = action.payload;
    },
    setAdvanceOptions: (state, action) => {
      state.advanceOptions = action.payload;
    },
    setAdvanceDropdownOptions: (state, action) => {
      state.advanceDropdownOptions = action.payload;
    },
    setAdvanceSearchClicked: (state, action) => {
      const { id, value } = action.payload;
      state.advanceSearchClicked[id] = value;
    },
    setAdvanceSearchSelectedData: (state, action) => {
      state.advanceSearchSelectedData = action.payload;
    },
    setSelectedCustomer: (state, action) => {
      state.selectedCustomer = action.payload;
    },
    setDefaultCustomerType: (state, action) => {
      state.defaultCustomerType = action.payload;
    },
    setPriorityCustomers: (state, action) => {
      state.priorityCustomers = action.payload;
    },
    setAllCustomers: (state, action) => {
      state.allCustomers = action.payload;
    },
    setIsApply: (state, action) => {
      state.isApply = action.payload;
    },
    setAllInsightView: (state, action) => {
      state.allInsightViews = action.payload;
    },
    setSelectedInsightView: (state, action) => {
      state.selectedInsightView = action.payload;
    },
    setSaveInsightViewBtnState: (state, action) => {
      state.saveInsightViewBtnState = action.payload;
    },
    setFilterInit: (state, action) => {
      state.custInsightsBrdId = null;
      state.cards = customerViewInitialState.cards;
      state.configureInsightsFilters =
        customerViewInitialState.configureInsightsFilters;

      state.engagementFilters = customerViewInitialState.engagementFilters;

      state.sitePerformanceFilters =
        customerViewInitialState.sitePerformanceFilters;

      state.siteUtilizationFilters =
        customerViewInitialState.siteUtilizationFilters;

      state.productMixFilters = customerViewInitialState.productMixFilters;

      state.payerMixFilters = customerViewInitialState.payerMixFilters;

      state.policyDetailsFilters =
        customerViewInitialState.policyDetailsFilters;

      state.ecosystemOpportunityFilters =
        customerViewInitialState.ecosystemOpportunityFilters;

      state.affiliationsFilters = customerViewInitialState.affiliationsFilters;

      state.copayAnalyticsFilters =
        customerViewInitialState.copayAnalyticsFilters;

      state.hcpFlag = customerViewInitialState.hcpFlag;
    },
    setVocAlertFlag: (state, action) => {
      state.vocAlertFlag = action.payload;
    },
    setActiveSectionTab: (state, action) => {
      state.activeSectionTab = action.payload;
    },
    setPayerTimeFrameDates: (state, action) => {
      state.payerTimeFrameDates = action.payload;
    },
    setTimespans: (state, action) => {
      state.timespans = action.payload;
    },
  },
});

export const {
  setCopayAnalyticsFilters,
  setCopayAnalyticsFiltersInitialState,
  setCopayAnalyticsEcosystem,
  setCopayAnalyticsProduct,
  setCopayAnalyticsTimePeriod,
  setCopayAnalyticsSquad,
  setCopayAnalyticsSiteName,
  setCopayCustomColumn,
  setSeletedView,
  setAllAccountOptions,
  setEcosystemOptions,
  setTimePeriodOption,
  setSelectedAccount,
  setSelectedEcosystem,

  setSelectedSquad,
  setSelectedDiscussionTopic,
  setSelectedStakeholderType,
  setSelectedTemplateName,
  setSelectedSurveyType,
  setSelectedPresentationName,
  setSelectedKeyMessage,
  setSelectedTimePeriod,
  setFocusAccountChecked,
  setIsAccountAvailable,
  setViewName,
  setKpiId,

  setKpiName,
  setDimensionName,
  setChartData,
  setTableData,
  setCards,
  appendCards,
  setProductOptions,
  setAllProductOptions,
  setSquadOptions,
  setAllSquadOptions,
  setTimePeriods,
  setTimePeriodOptions,
  setSelectedKpiName,
  setSelectedKPI,
  setNoDimensionValue,
  setBenchmarkNoDimensionValue,
  setShowSuccess,
  setAccountDetails,
  setInsightBoards,
  setContacts,
  setSelectedAccountId,
  setPayerMixPayer,
  setBookofBusiness,
  setBenifitType,
  setPayerProduct,
  setPayerIndication,
  setCompetitor,
  setPayerEcosystem,
  setBeamChart,
  setBeamChartSite,
  setCRMScores,
  setCrmPercent,
  setChartType,
  setCrmQuarter,
  setSurveyTotal,

  setEngagementFilters,
  resetEngagementFilters,
  setKeyMessageFilters,
  setPresentationNameFilters,
  setSurveyTypeFilters,
  setTemplateNameFilters,
  setStakeholderTypeFilters,
  setDiscussionTopicFilters,
  setChannelFilters,
  setMarketingFilters,
  setStakeholderName,
  setStakeholderType,
  setEngagement,
  setBrand,
  setIndication,
  setUserName,
  setUserRole,
  setSquad,
  setSites,
  setProducts,
  setCustomerInsightBoardId,
  setInsightType,
  setTimespan,
  setSiteExpression,
  setAffiliationsExpression,
  setPrductMixExpression,
  setHcpFlag,
  setPolicyDetailsFilters,
  setPolicyDetailsIniState,
  setPolicyDetailsPayer,
  setPolicyDetailsPlan,
  setPolicyDetailsProduct,
  setPolicyDetailsIndication,
  setPolicyDetailsCompetitorProduct,
  setPolicyDetailsEcosystemName,
  setPolicyDetailsPolicyState,
  setPolicyDetailsBookOfBusiness,
  setPolicyDetailsBenefitType,
  setEcosystemOpportunityFilters,
  setEcosystemOpportunityInitailState,
  setEcosystemOpportunityProduct,
  setEcosystemOpportunityIndication,
  setEcosystemOpportunityCompetitorBrand,
  setEcosystemOpportunityBookOfBusiness,
  setEcosystemOpportunityBenefitType,
  setEcosystemOpportunityRegion,
  setEcosystemOpportunityEcosystem,

  setExportLoader,
  setSelectedEngagement,
  setSitePerformanceSquad,
  setEcosystem,
  setIsAccountableProduct,
  setContractSegmentFilter,
  setSitePerformanceFilters,
  resetSitePerformanceFilters,
  setSiteUtilizationFilters,
  resetSiteUtilizationFilters,
  setSiteUtilizationEcosystem,
  setSiteUtilizationSite,
  setSiteUtilizationAddress,
  setSiteUtilizationSiteCity,
  setSiteUtilizationSiteState,
  setSiteUtilizationExpression,
  setSelectedSiteView,
  setFocusSiteChecked,
  setAllSiteOptions,
  setPayerMixFilters,
  setPayerMixFilterInitailState,
  setParentPayer,
  setPayer,
  setPayerTimeSpan,
  setAffiliationFilters,
  resetAffiliationFilters,
  setSiteFilters,
  setConfigInsightSiteFilter,
  setProductMixFilters,
  setProductMixFiltersIntitalState,
  setProductMixProduct,
  setProductMixSquad,
  setIsAccountableProductMix,
  setConfigureInsightFilters,
  setConfigureInsightSquad,
  setConfigureInsightEcosystem,
  setConfigureInsightProducts,
  setIsAccountableProductConfigure,
  setHCPCity,
  setHCPName,
  setHCPSpeciality,
  setHCPStakeholderType,
  setHCPState,
  setHCPZip,
  setSiteName,
  setSiteState,
  setSiteHIN,
  setSiteAddress,
  setEngagmentEcosystem,
  setSiteHCPStakeholderType,
  setSiteHCPName,
  setSiteHCPAddress,
  setSiteSpecility,
  setAppUsers,
  setColumnRestricted,
  setExcelColumnRestiction,
  setNotificationEmailStatus,
  setNotifyuserList,
  setAdvanceOptions,
  setAdvanceDropdownOptions,
  setPayerMixIniState,
  setFilterInit,
  resetCVStore,
  setAdvanceSearchClicked,
  setAdvanceSearchSelectedData,
  setSelectedCustomer,
  setIsApply,
  setAllCustomers,
  setFocusAccountDisabled,
  setPriorityCustomers,
  setDefaultCustomerType,
  setPrevFocusAccountChecked,
  setAllInsightView,
  setSelectedInsightView,
  setPaymentMethod,
  setSaveInsightViewBtnState,
  setCopayAllEcosystem,
  setSitePerformanceTimePeriod,
  setProductMixTimePeriod,
  resetProductMixFilters,
  setVocAlertFlag,
  setActiveSectionTab,
  setPayerTimeFrameDates,
  setTimespans,
} = customerViewSlice.actions;

export const customerViewSliceActions = customerViewSlice.actions;

export default customerViewSlice.reducer;
